/**
 * Whether the given request failed, either with a specific status code when `withCode`
 * is provided, or with any of the statuses considered as a failure.
 */
export const didRequestFail = (request: XMLHttpRequest, withCode?: number) => {
    const { status } = request;

    if (withCode) {
        return status === withCode;
    }

    return status === 404 || status === 401 || status >= 500;
};
